import { Button } from "@mindlercare/ui-web";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "components/typography";
import { withTranslation } from "react-i18next";
import { styled } from "styled-components";

interface ConfirmButtonWithDialogProps {
  buttonElement?: React.ReactElement;
  open: boolean;
  handleClose: (confirmed: boolean) => void;
  title?: string;
  description: string;
  children?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
  maxWidth?: string;
  t: (key: string) => string;
}

const ConfirmButtonWithDialog = (props: ConfirmButtonWithDialogProps) => {
  return (
    <>
      {props.buttonElement}
      <StyledDialog
        open={props.open}
        onClose={() => props.handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        $maxWidth={props.maxWidth}
      >
        <StyledDialogTitle id="alert-dialog-title">
          <span>{props.title}</span>
        </StyledDialogTitle>
        <StyledDialogContent>
          <Typography variant="h3" id="alert-dialog-description">
            {props.description}
          </Typography>
          {props.children}
        </StyledDialogContent>
        <StyledDialogActions>
          <Button
            variant="secondary"
            onClick={() => props.handleClose(false)}
            testId="cy-cancel-button"
          >
            {props.cancelText || props.t("CANCEL")}
          </Button>
          <Button
            variant="primary"
            onClick={() => props.handleClose(true)}
            testId="cy-confirm-button"
            disabled={props.confirmDisabled}
          >
            {props.confirmText || props.t("CONFIRM")}
          </Button>
        </StyledDialogActions>
      </StyledDialog>
    </>
  );
};

const StyledDialog = styled(Dialog)<{ $maxWidth?: string }>`
  & .MuiDialog-paper {
    padding: 40px;
    border-radius: 0px;
    ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}
  }
`;

const StyledDialogTitle = styled(DialogTitle)`
  padding: 0 0 14px;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 0 0 24px;
`;

const StyledDialogActions = styled(DialogActions)`
  justify-content: center;
  margin: 0;

  .actionButton {
    margin: 0;
    background-color: $primary;
    &:not(:first-of-type) {
      margin-left: 10px;
    }
    &:hover {
      background-color: $primary-dark;
    }
  }

  .cancelButton {
    background-color: transparent;
    border: 1px solid $middleGray2;

    span {
      color: $grays-black;
      font-weight: 500;
    }

    &:hover {
      border-color: $gray;
      background-color: transparent;
    }
  }
`;

export default withTranslation()(ConfirmButtonWithDialog);
